"use client";
import {
  TabDescription
} from "./chunk-E4C2X7VN.mjs";

// src/components/sections/AccordionsPanel/Fees.tsx
import { useEffect, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
function Fees({ title, itens }) {
  const [openedDescription, setOpenedDescription] = useState(
    null
  );
  const [waitScrollToTop, setWaitScrollToTop] = useState(false);
  useEffect(() => {
    const timerId = setTimeout(() => {
      setWaitScrollToTop(true);
    }, 1e3);
    return () => clearTimeout(timerId);
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: "mx-auto max-w-[455px] md:max-w-none", children: [
    /* @__PURE__ */ jsx(
      "h2",
      {
        className: "mb-24 font-display text-stone-500 text-4xl leading-8 font-bold",
        dangerouslySetInnerHTML: {
          __html: title
        }
      }
    ),
    /* @__PURE__ */ jsx("ul", { className: "flex flex-col", children: itens == null ? void 0 : itens.map(({ items, title: title2 }, index) => {
      return /* @__PURE__ */ jsx(
        TabDescription,
        {
          isOpen: waitScrollToTop && openedDescription === index,
          setIsOpen: () => setOpenedDescription(
            (value) => value !== index ? index : null
          ),
          title: title2,
          items: Array.isArray(items) ? items : []
        },
        title2
      );
    }) })
  ] });
}

export {
  Fees
};
